import { CSSProperties, ReactNode } from 'react'
import { BackgroundShading } from '../backgroundShading'
import WebApp from '@twa-dev/sdk'

function ButtonWrapper({
  children,
  style,
  startColor,
  endColor,
}: {
  children: ReactNode
  style?: CSSProperties
  startColor?: `#${string}`
  endColor?: `#${string}`
}) {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: '0',
        zIndex: 10,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '12px',
        ...style,
        paddingBottom: WebApp.platform == 'ios' ? 'calc(2vh + 12px)' : '12px',
      }}
    >
      {children}
      <BackgroundShading
        height="100%"
        width="100%"
        left="0"
        zIndex={-1}
        bottom="0"
        startColor={startColor ? startColor : '#FFFFFF00'}
        endColor={endColor ? endColor : '#00000000'}
      />
    </div>
  )
}

export default ButtonWrapper
